// Aplica a cor da tag à página inteira por variáveis CSS no <body>
// (`--colored-color` e `--colored-contrast`), lidas em forum/colored.less.

import isDark from 'flarum/common/utils/isDark';
let lastAppliedColor = undefined;

// Sem transições por 2 frames, para as cores trocarem de uma vez ao navegar.
function suppressTransitions() {
  document.documentElement.classList.add('colored--instant');
  requestAnimationFrame(() => requestAnimationFrame(() => document.documentElement.classList.remove('colored--instant')));
}
function updateThemeColor(color) {
  let meta = document.querySelector('meta[name="theme-color"]');
  if (!meta) {
    meta = document.createElement('meta');
    meta.name = 'theme-color';
    document.head.appendChild(meta);
  }
  const isColoredHeader = document.documentElement.getAttribute('data-colored-header') === 'true';
  if (color && isColoredHeader) {
    meta.content = color;
  } else {
    const primary = getComputedStyle(document.documentElement).getPropertyValue('--primary-color').trim();
    meta.content = primary || '#5c7cfa';
  }
}
export function applyColor(color) {
  if (color === lastAppliedColor) return;
  lastAppliedColor = color;
  suppressTransitions();
  if (color) {
    const contrast = isDark(color) ? 'var(--text-on-dark)' : 'var(--text-on-light)';
    document.body.style.setProperty('--colored-color', color);
    document.body.style.setProperty('--colored-contrast', contrast);
    document.body.classList.add('colored--active');
  } else {
    document.body.style.removeProperty('--colored-color');
    document.body.style.removeProperty('--colored-contrast');
    document.body.classList.remove('colored--active');
  }
  updateThemeColor(color ?? null);
}
export function clearColor() {
  applyColor(null);
}